import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ProductTableFilterSchema } from './-zod-schema';

// プロダクト（Product Central > プロダクト）一覧。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/products/_layout/')({
  validateSearch: zodValidator(ProductTableFilterSchema)
});